import React, {useState} from 'react';
import useStyles from "../styles";
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CheckedIcon from '../../../../../images/icons/checked-icon.svg';
import CheckedIconError from '../../../../../images/icons/checked-error-icon.svg';
import {aceitar, recusar} from "../../../../../services/usuario/UsuarioService";

const CardEquipeTecnica = (props) => {

  const { equipe, onAction } = props;
  const { id, nome, sobrenome, ocupacao, emailInstitucional, foto, siglaAtuacao, idUsuarioPerfil} = equipe;
  const classes = useStyles();

  const [checked, setChecked] = useState({});

  const handleAceitar = async () => {
    const response = await aceitar(id, idUsuarioPerfil);

    if (response && response.status === 200) {
      setChecked({ value: true, error: false, message: 'Aceito' })
      onAction();
    }
  }

  const handleRecusar = async () => {
    const response = await recusar(id, idUsuarioPerfil);

    if (response && response.status === 200) {
      setChecked({ value: true, error: true, message: 'Recusado' })
      onAction();
    }
  }

  return (
    <div className={classes.card}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {foto ? <Avatar src={foto} className={classes.avatar} /> :
          <div className={classes.imageReplace}>{nome.substring(0, 2).toUpperCase()}</div>
        }
        <div>
          <p className={classes.textInfo}><strong>{`${nome} ${sobrenome}`}</strong></p>
          <p className={classes.textInfo}>Sebrae {siglaAtuacao}</p>
          <p className={classes.textInfo}>{ocupacao}</p>
          <p className={classes.textInfo}>{emailInstitucional}</p>
        </div>
      </div>
      <div style={{ width: '25%' }}>
        {!checked.value ? <>
          <Button onClick={handleAceitar} className={classes.button}>Aceitar</Button>
          <Button onClick={handleRecusar} className={classes.button}>Recusar</Button>
        </> : <div className={classes.validadeInfo}>
            <img src={checked.error ? CheckedIconError : CheckedIcon} style={{ marginBottom: 10 }} />
            <p className={classes.textInfo}><strong>{checked.message}</strong></p>
          </div>
        }
      </div>
    </div>
  );
}

export default CardEquipeTecnica;
